import { Component, Inject, Input, Output, EventEmitter } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ButtonComponent } from '../button/button.component';
import { TextInputComponent } from '../text-input/text-input.component';

export type ModalVariant = 'confirm' | 'export' | 'custom';

@Component({
    selector: 'app-modal',
    standalone: true,
    templateUrl: './modal.component.html',
    styleUrls: ['./modal.component.scss'],
    imports: [CommonModule, ButtonComponent, TextInputComponent],
})
export class ModalComponent {
    title: string;
    confirmText: string;
    cancelText: string;
    variant: ModalVariant;
    description?: string;
    fileName?: string;

    constructor(
        public dialogRef: MatDialogRef<ModalComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any,
    ) {
        this.title = data.title || '';
        this.confirmText = data.confirmText || 'Confirm';
        this.cancelText = data.cancelText || 'Cancel';
        this.variant = data.variant || 'custom';
        this.description = data.description;
        this.fileName = data.fileName;
    }

    onCancel() {
        this.dialogRef.close('cancel');
    }

    onConfirm(): void {
        switch (this.variant) {
            case 'export':
                // If we needed the filename to display we would get it from the below line of code
                // this.dialogRef.close(this.fileName);
                this.dialogRef.close('export');
                break;
            case 'confirm':
                this.dialogRef.close('confirm');
                break;
            case 'custom':
                // Could return custom data on confirm
                break;
        }
    }
}
